var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9,
  _t10,
  _t11,
  _t12,
  _t13,
  _t14;
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { html, LitElement } from 'lit';
import { helper } from "../../common/helper";
import css from './style.pcss';
import SongArtwork from "../../common/images/song-artwork.svg";
var RTLTodayRadioPlaylist = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLTodayRadioPlaylist, _LitElement);
  function RTLTodayRadioPlaylist() {
    var _this;
    _classCallCheck(this, RTLTodayRadioPlaylist);
    _this = _callSuper(this, RTLTodayRadioPlaylist);
    _this.type = 'horizontal';
    _this.interval = setInterval(_this._fetchData.bind(_assertThisInitialized(_this)), 5000);
    return _this;
  }
  _createClass(RTLTodayRadioPlaylist, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(RTLTodayRadioPlaylist.prototype), "connectedCallback", this).call(this);
      this._fetchData();
    }
  }, {
    key: "_fetchData",
    value: function _fetchData() {
      var _this2 = this;
      this.apiUrl = `https://api-gate.rtl.lu/on-air/rtltodayradio/tracks?limit=3`;
      fetch(this.apiUrl).then(function (resp) {
        return resp.json();
      }).then(function (resp) {
        _this2.data = resp;
      }).catch(function (error) {
        if (this.interval) clearInterval(this.interval);
        console.log('ERROR: ' + error.message);
      }.bind(this));
    }
  }, {
    key: "_renderVertical",
    value: function _renderVertical() {
      return html(_t || (_t = _`
            <div class="onair">
            <ul class="latestsongs">
                ${0}
            </ul>
        </div>
        `), this.data.map(function (song) {
        return html(_t2 || (_t2 = _`
                    <li class="latestsongs__song song">
                        <div class="song__artwork">
                            ${0}
                        </div>
                        <div class="song__info">
                            <div class="song__time">
                                ${0}
                            </div><div class="song__time">
                            ${0}
                        </div>
                            <div class="song__info-artist">
                                <h3 class="song__artist">${0}</h3>
                                <h4 class="song__title">${0}</h4>
                            </div>

                        </div>
                    </li>
                `), song.album_art_url ? html(_t3 || (_t3 = _`<img class="song__artwork-img" src="${0}" />`), helper.stockify(song.album_art_url, 100)) : html(_t4 || (_t4 = _`<img class="song__artwork-img" src="${0}"/>`), SongArtwork), song.time, song.time, song.artist, song.title);
      }));
    }
  }, {
    key: "_renderHorizontal",
    value: function _renderHorizontal() {
      return html(_t5 || (_t5 = _`
            <div class="playlist-hz">
                <div class="playlist-hz__title">Last Songs</div>
                <div class="playlist-hz__songs">
                    ${0}
                </div>
            </div>
        `), this.data.map(function (song) {
        return html(_t6 || (_t6 = _`
                        <div class="song">
                            <div class="song__cover">
                                ${0}
                            </div>
                            <div class="song__info">
                                <div class="song__title"><b>${0}</b></br>${0}</div>
                                <div class="song__time">
                                    ${0}
                                </div>
                            </div>
                        </div>
                    `), song.album_art_url ? html(_t7 || (_t7 = _`<img class="song__artwork-img" src="${0}" />`), helper.stockify(song.album_art_url, 100)) : html(_t8 || (_t8 = _`<img class="song__artwork-img" src="${0}"/>`), SongArtwork), song.artist, song.title, song.time);
      }));
    }
  }, {
    key: "_renderPlayer",
    value: function _renderPlayer() {
      return html(_t9 || (_t9 = _`
            <div class="playlist-player">
                <div class="playlist-playlist-player__songs">
                    ${0}
                </div>
            </div>
        `), this.data.map(function (song) {
        return html(_t10 || (_t10 = _`
                        <div class="player-song">
                            <div class="player-song__cover">
                                ${0}
                            </div>
                            <div class="player-song__info">
                                <div class="player-song__title"><b>${0}</b></br>${0}</div>
                                <div class="player-song__time">
                                    ${0}
                                </div>
                            </div>
                        </div>
                    `), song.album_art_url ? html(_t11 || (_t11 = _`<img class="player-song__artwork-img" src="${0}" />`), helper.stockify(song.album_art_url, 100)) : html(_t12 || (_t12 = _`<img class="player-song__artwork-img" src="${0}"/>`), SongArtwork), song.artist, song.title, song.time);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      if (this.data == undefined) return html(_t13 || (_t13 = _`Loading...`));
      var output;
      switch (this.type) {
        case 'vertical':
          output = this._renderVertical();
          break;
        case 'player':
          output = this._renderPlayer();
          break;
        default:
          output = this._renderHorizontal();
      }
      return html(_t14 || (_t14 = _`
            <style>${0}</style>
            ${0}
        `), css, output);
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        data: {
          type: String
        },
        type: {
          type: String
        }
      };
    }
  }]);
  return RTLTodayRadioPlaylist;
}(LitElement);
export { RTLTodayRadioPlaylist as default };
window.customElements.define('rtl-today-radio-playlist', RTLTodayRadioPlaylist);